import { ComboSlug } from './types';

export const hasBannerUpgradePlanSlugs: ComboSlug[] = ['complete', 'advanced', 'essential'];
